import { render, staticRenderFns } from "./feeInfo.vue?vue&type=template&id=78d2ef4c&scoped=true"
import script from "./feeInfo.vue?vue&type=script&lang=js"
export * from "./feeInfo.vue?vue&type=script&lang=js"
import style0 from "./feeInfo.vue?vue&type=style&index=0&id=78d2ef4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d2ef4c",
  null
  
)

export default component.exports